import type { GA4AnalyticsEvent } from '@/domain/shared/types';
import type { ProductAd } from '@/scopes/product-ads/domain/types';

export function createProductAdsListViewedEvent({ ads, type }: { ads: ProductAd[]; type: string }): GA4AnalyticsEvent {
  return {
    event: 'eec.impressionView_sponsored_acco',
    ecommerce: {
      items: mapAds(ads, type),
    },
  };
}

export function createProductAdItemClickedEvent({ ads, type }: { ads: ProductAd[]; type: string }): GA4AnalyticsEvent {
  return {
    event: 'select_item',
    ecommerce: {
      items: mapAds(ads, type),
    },
  };
}

function mapAds(ads: ProductAd[], type: string) {
  return ads.map((ad, index) => mapAd(ad, type, index));
}

function mapAd(ad: ProductAd, type: string, index: number) {
  const category = ad.subHeading?.split(', ') || [];
  return {
    item_name: ad.heading,
    item_id: ad.accoId,
    item_category: category[0],
    item_category2: category[1],
    item_list_name: type,
    index: index + 1,
    quantity: '1',
  };
}
